import { PortableText } from '@portabletext/react'
import { QIcon_chevron_bold_down, QIcon_chevron_bold_up } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { CustomerTypeSlug, usePricingFAQData } from '../../../modules/apis/sanity'
import { s_pricing } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ptComponents } from '../../sanity/util'

const AccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [height, setHeight] = useState(0)
  const contentRef = useRef(null)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    if (isOpen) {
      setHeight(contentRef.current.scrollHeight)
    } else {
      setHeight(0)
    }
  }, [isOpen])

  return (
    <div className="border-gray-300">
      <div
        className="flex justify-between items-center cursor-pointer py-[8px] px-[12px] border-b-1"
        onClick={toggleAccordion}
      >
        <h3 className={classNames({ 'Body1-16Bd': isOpen, 'Body1-16Md': !isOpen })}>{title}</h3>
        <span>{isOpen ? <QIcon_chevron_bold_up /> : <QIcon_chevron_bold_down />}</span>
      </div>
      <div ref={contentRef} style={{ height }} className="overflow-hidden transition-all duration-300 ease-in-out">
        <div className="p-[16px] Body1-16Md text-gray-700 bg-gray-50">{children}</div>
      </div>
    </div>
  )
}

interface IPricingFaqSection {
  slug: CustomerTypeSlug
  className?: string
}

const PricingFaqSection = ({ slug, className = '' }: IPricingFaqSection) => {
  const { t, locale } = useTranslation()
  const { data: faqData } = usePricingFAQData(slug)
  const faqDataList = faqData?.[locale] || []

  if (faqDataList.length === 0) return null
  return (
    <div className={classNames('sm:p-[32px] p-[16px] sm:border-1 rounded-[6px] select-none', className)}>
      <div className="Headline2-24Bd mb-[16px]">{t(s_pricing.qna.title)}</div>
      {faqDataList.map((data, i) => {
        return (
          <AccordionItem key={i} title={data?.title || ''}>
            <div className="lists-class ">
              {data?.faq?.content && <PortableText value={data?.faq?.content} components={ptComponents} />}
            </div>
          </AccordionItem>
        )
      })}
    </div>
  )
}

export default PricingFaqSection
